import { useHistory, useLocation } from 'react-router-dom';
import { useAppSelector } from 'redux/hooks';
import { selectPermission } from 'redux/global';
import { redirectLiveDemoToTry, shouldExitLiveDemoToTry } from 'utils';
import { ERP_PATHS } from './Layout/erpModulePaths';
import { canAccessMetrics } from './Settings/redux';

export const usePath = () => {
  const homePaths = ['/signin', '/register', '/signup', '/forgot', '/addH', '/pricing', '/unsubscribe', '/live', '/employee-invite'];
  const location = useLocation();
  const history = useHistory();
  const permission = useAppSelector(selectPermission);

  const isPublicFormPath = location.pathname === '/form' || location.pathname.startsWith('/form/');
  const isHomePath = !!(location.pathname === '/' || isPublicFormPath
    || homePaths.find((p) => location.pathname.includes(p)));

  const navigateToHome = (perm?: number | null, opts?: { replace?: boolean }) => {
    const permission1 = (perm || perm === 0) ? perm : permission;
    if (permission1 == null) {
      // Try-live exit: send demos to marketing /try instead of app sign-in.
      if (shouldExitLiveDemoToTry()) {
        redirectLiveDemoToTry();
        return;
      }
      if (opts?.replace) history.replace('/');
      else history.push('/');
      return;
    }
    // Default app home — Command center (Manager+); others land on Master data.
    const path = canAccessMetrics(permission1) ? ERP_PATHS.commandCenter : ERP_PATHS.records;
    if (opts?.replace) history.replace(path);
    else history.push(path);
  };

  return { isHomePath, navigateToHome };
};
